import React from 'react';

interface CategoryBadgesProps {
  categories: string[];
  className?: string;
}

const CategoryBadges: React.FC<CategoryBadgesProps> = ({ categories, className = '' }) => {
  if (!categories || categories.length === 0) {
    return <span className={`text-muted ${className}`}>No categories</span>;
  }

  return (
    <span className={className}>
      {categories.map((category, index) => (
        <span key={index}>
          <span 
          className="badge bg-primary me-1 mb-1"
          style={{whiteSpace: "wrap"}}
          >{category}</span>
          {index < categories.length - 1 ? ' ' : ''}
        </span>
      ))}
    </span>
  );
};

export default CategoryBadges;